import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

import { getFromBreakpoint } from '../../styles/breakpoints';

export const useCustomStyles = makeStyles()((theme) => ({
	noBookingsBlockContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${theme.spacing.xlarge} ${theme.spacing.medium}`,
		borderRadius: theme.spacing.tiny,
		backgroundColor: theme.palette.yellow[20],
		textAlign: 'center',

		[getFromBreakpoint('lg')]: {
			padding: `${theme.spacing.xxlarge} ${theme.spacing.medium}`,
		},

		'> p:last-of-type': {
			marginBottom: 0,
		},
	},
	icon: {
		paddingBottom: theme.spacing.small,
	},
}));
